import type { BrowseFilters } from '../../hooks/use-investor-assistant'

/** The five chips of Browse, as the prototype has them: all, joined this week, raising now, Europe, fits your focus. */
export type SearchChip = 'all' | 'week' | 'raising' | 'europe' | 'focus'
export type Sort = 'joined' | 'name'

const CHIP_FILTERS: Record<
  Exclude<SearchChip, 'all'>,
  Pick<BrowseFilters, 'signedUp' | 'raising' | 'region' | 'focus'>
> = {
  week: { signedUp: 'week' },
  raising: { raising: 'now' },
  europe: { region: 'europe' },
  focus: { focus: 'fits' },
}

/** A name search replaces the chips: the chip is ignored while a name is typed. */
export const filtersOf = (q: string | undefined, chip: SearchChip, sort: Sort): BrowseFilters => ({
  sort,
  ...(q ? { q } : chip !== 'all' && CHIP_FILTERS[chip]),
})
